import React from "react";
import { useFamilyData } from "../../hooks/useFamilyData";

const getTimeMs = (value) => {
  if (!value) return 0;
  if (typeof value === "number") return value;
  if (value.toDate) return value.toDate().getTime();
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? 0 : date.getTime();
};

export default function WeeklyRecapCard({ familyId }) {
  const { history = [] } = useFamilyData(familyId);
  const now = Date.now();
  const weekAgo = now - 7 * 24 * 60 * 60 * 1000;
  const recent = history.filter(h => getTimeMs(h.createdAt) >= weekAgo);

  const summary = recent.reduce(
    (acc, entry) => {
      if (entry.type === "approve") {
        acc.approved += 1;
        acc.points += Number(entry.pointsAwarded ?? entry.points) || 0;
      }
      if (entry.type === "fail" || entry.type === "expired") acc.failed += 1;
      if (entry.type === "approve" || entry.type === "fail" || entry.type === "expired") {
        const name = entry.kidName || "Unknown";
        if (!acc.kidCounts[name]) acc.kidCounts[name] = { approves: 0, fails: 0 };
        if (entry.type === "approve") acc.kidCounts[name].approves += 1;
        if (entry.type === "fail" || entry.type === "expired") acc.kidCounts[name].fails += 1;
      }
      return acc;
    },
    { approved: 0, failed: 0, points: 0, kidCounts: {} }
  );

  const topKid = Object.entries(summary.kidCounts)
    .map(([name, data]) => {
      const total = data.approves + data.fails;
      const percentage = total > 0 ? Math.round((data.approves / total) * 100) : 0;
      return [name, percentage, total];
    })
    .sort((a, b) => b[1] - a[1])[0];

  return (
    <div className="glass parent-card">
      <div className="header-flex">
        <h2>Weekly Recap</h2>
      </div>
      <div className="card-body">
        {recent.length === 0 ? (
          <p style={{ textAlign: "center", opacity: 0.6 }}>No activity in the last 7 days.</p>
        ) : (
          <>
            <div className="parent-list-item">
              <span>✅ Approvals</span>
              <strong>{summary.approved}</strong>
            </div>
            <div className="parent-list-item">
              <span>❌ Fails</span>
              <strong>{summary.failed}</strong>
            </div>
            <div className="parent-list-item">
              <span>⭐ Points Awarded</span>
              <strong>{summary.points}</strong>
            </div>
            {topKid && (
              <div className="parent-list-item">
                <span>🏆 Top Kid (First-Try %)</span>
                <strong>{topKid[0]} • {topKid[1]}%</strong>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
